import React from "react";
import Marquee from "react-fast-marquee";

export default function GoldMarquee({ items, speed = 35 }) {
  return (
    <div className="py-4 overflow-hidden">
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="display-mega text-neutral-900 text-2xl md:text-3xl px-6 whitespace-nowrap">{it}</span>
            <span className="w-2 h-2 rounded-full bg-[#0B0B0D]" />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
